import React, { FC } from 'react';
import { Text } from 'react-native';
import { font } from '@styles/fonts';
import { BaseTopBlockProps, NCFileNameProp } from '@v2/pages/machines/modules/now/components/Overview/components/TopBlock/types';

interface NCFileNameProps extends BaseTopBlockProps, NCFileNameProp {}

const NCFileName: FC<NCFileNameProps> = ({ C, ncFileName }) => {
  return <Text style={[font.Headline, { color: C('Label/Light/Primary') }]}>{ncFileName}</Text>;
};

export default NCFileName;
